<template>
	<v-dialog v-model="$store.state.admin.showEditDialog" max-width="500px">
		<validation-observer ref="observerEdit" v-slot="validation">
			<v-form>
				<v-card>
					<v-card-title>
						<span class="headline">Edit</span>
					</v-card-title>
					<v-card-text>
						<template v-for="(inputItemVals, inputItemKey) in contents[contentKey].inputItems">
							<v-row :key="inputItemKey" dense>
								<v-col>
									<validation-provider
											:rules="getValidationRules(inputItemVals.rules)"
											:name="inputItemVals.title"
											mode="lazy"
											v-slot="{ errors }">
										<v-text-field
												v-model="$store.state.admin.editItem[inputItemKey]"
												:label="inputItemVals.title"
												:error-messages="errors" />
									</validation-provider>
								</v-col>
							</v-row>
						</template>
					</v-card-text>
					<v-card-actions>
						<v-row dense justify="center">
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										:disabled="!validation.passed && !validation.valid"
										@click="$_admnEdtDlg_save()">
									Save
								</v-btn>
							</v-col>
							<v-col cols="auto">
								<v-btn	class="customVBtn"
										@click="$_admnEdtDlg_close()">
									Cancel
								</v-btn>
							</v-col>
						</v-row>
					</v-card-actions>
				</v-card>
			</v-form>
		</validation-observer>
	</v-dialog>
</template>

<script>
	export default {
		name: 'AdminEditDialog',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		methods: {
			$_admnEdtDlg_save() {
				const self_ = this;

				self_.$emit('edited')

				self_.$_admnEdtDlg_close()
			},
			$_admnEdtDlg_close() {
				const self_ = this;
				const refs_ = self_.$refs;

				const observer_ = refs_.observerEdit;
				if(!self_.isEmpty(observer_)) {
					Object.keys(observer_).forEach(key => observer_[key].reset())
				}

				self_.setAdminState('showEditDialog', false)
			}
		}
	}
</script>

<style scoped>
</style>
